import React, {useEffect, useRef, useState} from "react";
import {Form, Row, Col, Button, Modal, InputGroup} from "react-bootstrap";
import {api} from "../api";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import axiosInstance from "../axiosInstance";
import {
    getRefreshToken,
    getTokenFromSession,
    refreshIdToken,
} from "../services/authenticate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCamera, faPlus, faSearch} from "@fortawesome/free-solid-svg-icons";
import Webcam from "react-webcam";
import {useDispatch, useSelector} from "react-redux";
import {addAge} from "../Store/ageState";
import {addLanguage} from "../Store/languageState";
import {addGenre} from "../Store/genreState";
import {addSource} from "../Store/source";
import {useNavigate} from "react-router-dom";
import {getImageUrlUsingIsbn, saveImageDetails} from "../Api/imageApi";
import {getStockDetailsUsingStockId, postStockDataAndBookData} from "../Api/stockApi";
import {searchBookUsingIsbnAndOptions} from "../Api/bookApi";

const StockSearch = () => {
    const isbnInputRef = useRef(null);
    const dispatch = useDispatch();
    const ageGroup = useSelector((state) => state.Age.items || []);
    const genre = useSelector((state) => state.Genre.genre || []);
    const language = useSelector((state) => state.Language.language || []);
    const source = useSelector((state) => state.Source.source || []);
    const [lendingPriceRate, setLendingPriceRate] = useState(5);
    const [sellingPriceRate, setSellingPriceRate] = useState(10);
    const [newState, setNewState] = useState(true);
    const navigate = useNavigate();
    const emptyStockItem = {
        isbn: "",
        stockId: "",
        status: "Available",
        sellingPrice: "",
        lendingPricePerDay: "",
        lastCustomerPurchased: "",
        lastCustomerBorrowed: "",
        saleDate: "",
        lastBorrowedDate: "",
        lastExpectedReturnDate: "",
        actualReturnDate: "",
        costPrice: "",
        source: "",
        condition: "New",
        updatedTimestamp: "",
        mrp: "",
    }
    const emptyBookData = {
        isbn: "",
        title: "",
        author: "",
        category: "",
        costPrice: "",
        ageGroup: "",
        publisher: "",
        isSeries: "",
        seriesId: "",
        publishedDate: "",
        currency: "",
        subject: "",
        page: "",
        size: "",
        weightInGrams: "",
        language: "",
        isBoxSet: "",
        bindingType: "",
        startingSellingPrice: "",
        startingLendingPrice: "",
        coverImagePath: "",
        description: "",
        status: "Available",
    };
    const [stockItem, setStockItem] = useState(emptyStockItem);
    const [book, setBook] = useState(emptyBookData);
    const [selectedOptions, setSelectedOptions] = useState([
        "IsbnDb",
        "OpenLibrary",
        "Google",
    ]);

    const handleCheckboxChange = (value) => {
        setSelectedOptions((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };
    useEffect(() => {
        if (newState) {
            const updatePrices = () => {
                const costPrice = parseFloat(stockItem.costPrice) || 0;
                const sellingRate = (costPrice / 100) * sellingPriceRate;
                const sellingPrice = costPrice + sellingRate;
                const lendingPricePerDay = (sellingPrice / 100) * lendingPriceRate;
                setStockItem((prevStockItem) => ({
                    ...prevStockItem,
                    lendingPricePerDay: lendingPricePerDay.toFixed(2),
                    sellingPrice: sellingPrice.toFixed(2),
                }));
            };

            updatePrices();
        }
    }, [newState, stockItem.costPrice, lendingPriceRate, sellingPriceRate]);

    // Adding to the state section code
    const [show, setShow] = useState(false);
    const [input, setInput] = useState("");
    const [category, setCategory] = useState("");

    const handleShow = (category) => {
        setCategory(category);
        setShow(!show);
        setInput("");
    };

    const addDetails = (input, category) => {
        if (category === "age") {
            dispatch(addAge(input));
        }
        if (category === "genre") {
            dispatch(addGenre(input));
        }
        if (category === "language") {
            dispatch(addLanguage(input));
        }
        if (category === "source") {
            dispatch(addSource(input));
        }
        setCategory("");
        setShow(!show);
        setInput("");
    };

    // Capture image section code
    const webCamRef = useRef();
    const [imageSrc, setImageSrc] = useState(null);
    const [open, setOpen] = useState(false);

    const capture = () => {
        const imageSrc = webCamRef.current.getScreenshot();
        setImageSrc(imageSrc);
        setBook({...book, coverImageUrl: imageSrc});
    };

    //  uploading imge code section
    const upload = async () => {
        if (book.isbn === "") {
            alert("Add the ISBN value");
            return;
        }
        if (!imageSrc) {
            alert("Capture the image");
            return;
        }
        if (!imageSrc.startsWith("data:image/jpeg;base64,")) {
            alert("Invalid image format");
            return;
        }

        const result = await saveImageDetails({imageDetails: imageSrc, isbn: book.isbn});
        if (result.status === 200) {
            alert("Image uploaded successfully");
        } else {
            alert("Upload failed");
        }
    };

    // uploading image file section code
    const fileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            setImageSrc(result);
            setBook((prevFormData) => ({
                ...prevFormData,
                coverImageUrl: result,
            }));
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    // Function to reset all form fields
    const handleReset = () => {
        setBook(emptyBookData);
        setStockItem(emptyStockItem);
    };
    // Search for book details using stockid section code

    const searchStockId = async ({stockId}) => {
        setBook(emptyBookData);
        setStockItem({...emptyStockItem, stockId: stockId || ""});
        setNewState(false);
        try {
            const response = await getStockDetailsUsingStockId({stockId});
            const {bookInfo, stockItem} = response.data;
            setBook({
                ...bookInfo,
                coverImageUrl: `${process.env.REACT_APP_IMAGE_BASE_URL}${stockItem.isbn}.jpg`,
            });
            setStockItem(stockItem);
            setNewState(false);
        } catch (error) {
            if (error.response?.status === 404) {
                alert("No stock ID found. Please add a Stock ID.");
                setNewState(true);
                isbnInputRef.current.focus();
            } else {
                console.error("Unexpected error:", error);
            }
        }
        if (!stockId) {
            isbnInputRef.current.focus();
        }
    };


    const saveStock = async (e) => {
        e.preventDefault();
        try {
            const data = {
                book,
                stockItem,
            };
            const response = await postStockDataAndBookData({data});
            alert("Stock item saved successfully");
            setBook(emptyBookData);
            setStockItem(emptyStockItem);
            setNewState(true);
        } catch (error) {
            console.error("Error saving stock:", error);
        }
    };

    const searchBook = async ({isbn}) => {
        setBook(emptyBookData)
        setStockItem(emptyStockItem)
        const response = await searchBookUsingIsbnAndOptions({isbn, options: selectedOptions});
        const data = response.data;
        setNewState(true);
        setBook({
            isbn: data.isbn,
            title: data.title,
            author: data.author,
            category: data.category,
            ageGroup: data.ageGroup,
            publisher: data.publisher,
            isSeries: data.isSeries,
            seriesId: data.seriesId,
            publishedDate: data.publishedDate,
            currency: data.currency,
            subject: data.subject,
            pageCount: data.pageCount,
            sizeInCm: data.sizeInCm,
            weightInGrams: data.weightInGrams,
            language: data.language,
            isBoxSet: data.isBoxSet,
            bindingType: data.bindingType,
            startingPurchasePrice: data.startingPurchasePrice,
            startingLendingPrice: data.startingLendingPrice,
            coverImageUrl: `${process.env.REACT_APP_IMAGE_BASE_URL}${data.isbn}.jpg`,
            description: data.description,
            status: data.status,
        });
        setStockItem({...emptyStockItem, isbn: data.isbn, condition: "New", status: "Available"});
    };

    const fetchImage = async () => {
        const response = await getImageUrlUsingIsbn({isbn: stockItem.isbn});
        if (response.status === 200) {
            setBook((prevBook) => ({
                ...prevBook,
                coverImageUrl: `${process.env.REACT_APP_IMAGE_BASE_URL}${stockItem.isbn}.jpg`,
            }));
        }
    };

    return (
        <div>
            <div>
                <Header/>
            </div>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "100px",
                    marginLeft: "100px",
                }}
            >
                <Form className="w-75" onSubmit={saveStock}>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="stockID">
                                <Form.Label>StockId</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter StockId"
                                    value={stockItem.stockId}
                                    required
                                    onChange={(e) =>
                                        setStockItem({...stockItem, stockId: e.target.value})
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            searchStockId({stockId: stockItem.stockId});
                                        }
                                    }}
                                />
                            </Form.Group>
                            <div style={{marginTop: "20px"}}>
                                <Button
                                    type="button"
                                    onClick={() => searchStockId({stockId: stockItem.stockId})}
                                >
                                    Search
                                </Button>
                            </div>
                        </Col>
                        <Col md={3}>
                            <Row>
                                <Col>
                                    <Form.Group controlId="Isbn" className="mb-3">
                                        <Form.Label>Isbn</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                value={book.isbn}
                                                placeholder="Enter ISBN"
                                                required
                                                onChange={(e) => {
                                                    const isbn = e.target.value;
                                                    setBook((prevBook) => ({...prevBook, isbn}));
                                                    setStockItem((prevStockItem) => ({
                                                        ...prevStockItem,
                                                        isbn,
                                                    }));
                                                }}
                                                ref={isbnInputRef}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        searchBook({isbn: book.isbn});
                                                    }
                                                }}
                                            />
                                            <InputGroup.Text
                                                onClick={() => searchBook({isbn: book.isbn})}
                                                style={{cursor: "pointer"}}
                                            >
                                                <FontAwesomeIcon icon={faSearch}/>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group controlId="checkboxGroup">
                                        <Form.Label>Options</Form.Label>
                                        <div>
                                            <Form.Check
                                                type="checkbox"
                                                label="IsbnDb"
                                                value="IsbnDb"
                                                checked={selectedOptions.includes("IsbnDb")}
                                                onChange={() => handleCheckboxChange("IsbnDb")}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="OpenLibrary"
                                                value="OpenLibrary"
                                                checked={selectedOptions.includes("OpenLibrary")}
                                                onChange={() => handleCheckboxChange("OpenLibrary")}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="Google"
                                                value="Google"
                                                checked={selectedOptions.includes("Google")}
                                                onChange={() => handleCheckboxChange("Google")}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="title">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={book.title}
                                    required
                                    onChange={(e) => setBook({...book, title: e.target.value})}
                                />
                            </Form.Group>
                        </Col>
                        <Col
                            md={3}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                    width: "150%",
                                    height: "400px",
                                    position: "relative",
                                    padding: "0",
                                    overflow: "hidden",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                {open ? (
                                    <Webcam // Set to empty string
                                        audio={false}
                                        ref={webCamRef}
                                        screenshotFormat="image/jpeg"
                                        width="100%"
                                        height="100%"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : book.coverImageUrl ? (
                                    <img
                                        src={book.coverImageUrl || ""}
                                        alt="Book Cover"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            borderRadius: "8px",
                                        }}
                                    />
                                ) : (
                                    <span style={{color: "grey"}}>Image not available</span>
                                )}

                                {imageSrc ? (
                                    <Button
                                        variant="light"
                                        className="position-absolute"
                                        style={{
                                            borderRadius: "50%",
                                            bottom: "10px",
                                            right: "10px",
                                            padding: "8px",
                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        }}
                                        onClick={upload}
                                    >
                                        Upload
                                    </Button>
                                ) : (
                                    <Button
                                        variant="light"
                                        className="position-absolute"
                                        style={{
                                            borderRadius: "50%",
                                            bottom: "10px",
                                            right: "10px",
                                            padding: "8px",
                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        }}
                                        onClick={() => setOpen(true)}
                                    >
                                        <FontAwesomeIcon icon={faCamera}/>
                                    </Button>
                                )}
                            </div>

                            {open && (
                                <Button
                                    type="button"
                                    style={{
                                        borderRadius: "50%",
                                        bottom: "10px",
                                        right: "10px",
                                        padding: "8px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    }}
                                    onClick={() => {
                                        capture();
                                        setOpen(false);
                                    }}
                                >
                                    Capture
                                </Button>
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}></Col>
                        <Col md={3}></Col>
                        <Col md={3}></Col>
                        <Col md={3}>
                            {" "}
                            <div
                                style={{display: "flex", alignItems: "center", gap: "5px"}}
                            >
                                <input type="file" accept="image/*" onChange={fileUpload}/>
                                <button type="button" onClick={fetchImage}>
                                    Internet Search
                                </button>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="lendingPriceRate">
                                <Form.Label>LendingCalculation(% of sp)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={lendingPriceRate}
                                    onChange={(e) => setLendingPriceRate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="salesPriceRate">
                                <Form.Label>Profit(%)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={sellingPriceRate}
                                    onChange={(e) => setSellingPriceRate(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="genre">
                                <Form.Label>Category</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={book.category || ""}
                                        required
                                        onChange={(e) =>
                                            setBook({...book, category: e.target.value})
                                        }
                                    >
                                        {!genre.includes(book.category) && (
                                            <option value=""></option>
                                        )}
                                        {genre.map((genreItem, index) => (
                                            <option key={index} value={genreItem}>
                                                {genreItem}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => handleShow("genre")}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="ageGroup">
                                <Form.Label className="custom-label">Age Group</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={book.ageGroup || ""}
                                        required
                                        onChange={(e) =>
                                            setBook({
                                                ...book,
                                                ageGroup: e.target.value,
                                            })
                                        }
                                    >
                                        {" "}
                                        {!ageGroup.includes(book.ageGroup) && (
                                            <option value=""></option>
                                        )}
                                        {ageGroup.map((age, index) => (
                                            <option key={index} value={age}>
                                                {age}
                                            </option>
                                        ))}
                                    </Form.Select>

                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => {
                                            handleShow("age");
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="costPrice"></Form.Group>
                            <Form.Label>CostPrice</Form.Label>
                            <Form.Control
                                type="text"
                                value={stockItem.costPrice}
                                required
                                onChange={(e) => {
                                    const newCostPrice = e.target.value;
                                    if (newCostPrice !== stockItem.costPrice) {
                                        setNewState(true);
                                        setStockItem({...stockItem, costPrice: newCostPrice});
                                    }
                                }}
                            ></Form.Control>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="lendingPrice">
                                <Form.Label>LendingPricePerDay</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.lendingPricePerDay}
                                    required
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            lendingPricePerDay: e.target.value,
                                        })
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="sellingPrice">
                                <Form.Label>SellingPrice</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.sellingPrice}
                                    required
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            sellingPrice: e.target.value,
                                        })
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="author">
                                <Form.Label>Authors</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={book.author}
                                    required
                                    onChange={(e) => setBook({...book, author: e.target.value})}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="status">
                                <Form.Label>StockStatus</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.status || "Available"}
                                    onChange={(e) =>
                                        setStockItem({...stockItem, status: e.target.value})
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="status">
                                <Form.Label>MRP</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.mrp}
                                    required
                                    onChange={(e) =>
                                        setStockItem({...stockItem, mrp: e.target.value})
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="isSeries">
                                <Form.Label>Is Series</Form.Label>
                                <Form.Select
                                    value={book.isSeries}
                                    onChange={(e) =>
                                        setBook({...book, isSeries: e.target.value})
                                    }
                                >
                                    <option value="false">False</option>
                                    <option value="true">True</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="publisher"></Form.Group>
                            <Form.Label>Publisher</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.publisher}
                                onChange={(e) =>
                                    setBook({...book, publisher: e.target.value})
                                }
                            ></Form.Control>
                        </Col>
                    </Row>
                    <Row className="mb-3"></Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="source">
                                <Form.Label>Source</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={stockItem.source || ""}
                                        onChange={(e) =>
                                            setStockItem({...stockItem, source: e.target.value})
                                        }
                                    >
                                        {!source.includes(stockItem.source) && (
                                            <option value=""></option>
                                        )}
                                        {source.map((value, index) => (
                                            <option key={index} value={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => handleShow("source")}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="condition">
                                <Form.Label>Condition</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={stockItem.condition || ""}
                                        onChange={(e) =>
                                            setStockItem({...stockItem, condition: e.target.value})
                                        }
                                    >
                                        <option value="NEW">New</option>
                                        <option value="Used">Used</option>
                                    </Form.Select>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="language">
                                <Form.Label>Language</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={book.language || ""}
                                        onChange={(e) =>
                                            setBook({...book, language: e.target.value})
                                        }
                                    >
                                        {!language.includes(book.language) && (
                                            <option value=""></option>
                                        )}
                                        {language.map((value, index) => (
                                            <option key={index} value={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => handleShow("language")}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="isBoxSet"></Form.Group>
                            <Form.Label>IsBoxSet</Form.Label>
                            <Form.Select
                                value={book.isBoxSet}
                                onChange={(e) => setBook({...book, isBoxSet: e.target.value})}
                            >
                                <option value="false">False</option>
                                <option value="true">True</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="weightInGrams"></Form.Group>
                            <Form.Label>WeightInGrams</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.weightInGrams}
                                required
                                onChange={(e) =>
                                    setBook({...book, weightInGrams: e.target.value})
                                }
                            ></Form.Control>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="currency"></Form.Group>
                            <Form.Label>Currency</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.currency}
                                onChange={(e) => setBook({...book, currency: e.target.value})}
                            ></Form.Control>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="subject">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={book.subject}
                                    onChange={(e) =>
                                        setBook({
                                            ...book,
                                            subject: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="publishedDate"></Form.Group>
                            <Form.Label>PublishedDate</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.publishedDate}
                                onChange={(e) =>
                                    setBook({...book, publishedDate: e.target.value})
                                }
                            ></Form.Control>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="sizeInCm">
                                <Form.Label>sizeInCm</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={book.sizeInCm}
                                    onChange={(e) =>
                                        setBook({
                                            ...book,
                                            sizeInCm: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="pageCount"></Form.Group>
                            <Form.Label>pageCount</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.pageCount}
                                onChange={(e) =>
                                    setBook({...book, pageCount: e.target.value})
                                }
                            ></Form.Control>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="bindingType">
                                <Form.Label>BindingType</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={book.bindingType}
                                    onChange={(e) =>
                                        setBook({
                                            ...book,
                                            bindingType: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="lastCustomerBorrowed">
                                <Form.Label>LastCustomerBorrowed</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.lastCustomerBorrowed}
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            lastCustomerBorrowed: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="salesDate">
                                <Form.Label>SalesDate</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.saleDate}
                                    onChange={(e) =>
                                        setStockItem({...stockItem, saleDate: e.target.value})
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="description"></Form.Group>
                            <Form.Label style={{width: "500px"}}>Description</Form.Label>
                            <Form.Control
                                type="text"
                                value={book.description}
                                onChange={(e) =>
                                    setBook({
                                        ...book,
                                        description: e.target.value,
                                    })
                                }
                            ></Form.Control>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="status">
                                <Form.Label>BookStatus</Form.Label> {/* Fixed typo in label */}
                                <Form.Control
                                    type="text"
                                    value={book.status || "Available"}
                                    onChange={(e) => setBook({...book, status: e.target.value})}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="lastBorrowDate">
                                <Form.Label>LastBorrowDate</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.lastBorrowedDate}
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            lastBorrowedDate: e.target.value,
                                        })
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="returnDate">
                                <Form.Label>ReturnDate</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.actualReturnDate}
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            actualReturnDate: e.target.value,
                                        })
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="lastExpectedReturnDate">
                                <Form.Label>LastExpectedReturnDate</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.lastExpectedReturnDate}
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            lastExpectedReturnDate: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="lastCustomerPurchased">
                                <Form.Label>LastCustomerPurchased</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={stockItem.lastCustomerPurchased}
                                    onChange={(e) =>
                                        setStockItem({
                                            ...stockItem,
                                            lastCustomerPurchased: e.target.value,
                                        })
                                    }
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button type="submit">Save</Button>
                    <Button onClick={handleReset} style={{marginLeft: "20px"}}>
                        Clear
                    </Button>
                </Form>
                <Modal show={show} onHide={() => handleShow("")}>
                    <Modal.Header closeButton>
                        <Modal.Title>Enter the value</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="ageCategory">
                                <Form.Label>{`Enter the ${category}`}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={() => {
                                addDetails(input, category);
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <div style={{marginBottom: "50px"}}></div>
        </div>
    );
};

export default StockSearch;
